/**
 * Feature flags for the app. Controlled via environment variables.
 * Set REACT_APP_FEATURE_* to "true" to enable, anything else or unset to disable.
 * When unset, features default to true so existing behaviour is preserved.
 */

function isFeatureEnabled(envKey: string, defaultValue = true): boolean {
  const value = process.env[envKey];
  if (value === undefined || value === "") {
    return defaultValue;
  }
  return value.toLowerCase() === "true";
}

export const featureFlags = {
  /** Club Memberships page (regular users viewing their club memberships) */
  clubMemberships: isFeatureEnabled(
    "REACT_APP_FEATURE_CLUB_MEMBERSHIPS",
    true,
  ),
  /** Club Administration page (club admins managing clubs, groups, invoices) */
  clubAdministration: isFeatureEnabled(
    "REACT_APP_FEATURE_CLUB_ADMINISTRATION",
    true,
  ),
  /** Venue hire (DIY slot booking for club members) */
  venueHire: isFeatureEnabled("REACT_APP_FEATURE_VENUE_HIRE", false),
  /** One-off sessions (standalone sessions without a training group) */
  oneOffSessions: isFeatureEnabled("REACT_APP_FEATURE_ONE_OFF_SESSIONS", false),
} as const;
